import styled from "styled-components";

import RootGrid from "components/elements/RootGrid/RootGrid";

export const SignUpRootGrid = styled(RootGrid)((p) => {
  return {
    minHeight: p.theme.layout.signupMinHeight,
  };
});
